/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/* Utils */
import {
  getFirstGenre,
  isShow,
  joinArrayWithSeparator,
  joinArrayWithSpace,
  getRating,
} from '../../utils/metaDataUtils';

export function useSubtitleCatalogCard(content) {
  const { formatMessage } = useIntl();
  return useMemo(() => joinArrayWithSpace([
    getRating(content),
    joinArrayWithSeparator([
      isShow(content) && formatMessage({ id: 'common.serie' }),
      getFirstGenre(content),
      !isShow(content) && content?.releaseYear,
    ]),
  ]), [content, formatMessage]);
}
